import { render } from "./Hero.vue?vue&type=template&id=d5a3ec3e"
const script = {}
script.render = render

export default script